import { base60ADecimalBase100 } from './formatoHorasTrabajo';

/** Hora de salida a partir de entrada (HH:MM) y horas trabajadas (decimal o HH:MM). */
export function calcularHoraSalidaTareoPorHoras(horaEntrada, horasTrabajadas) {
  if (!horaEntrada || horasTrabajadas == null || horasTrabajadas === '') return '';

  const horasTrabajadasNum =
    typeof horasTrabajadas === 'string' && String(horasTrabajadas).includes(':')
      ? base60ADecimalBase100(horasTrabajadas)
      : parseFloat(horasTrabajadas);

  if (!Number.isFinite(horasTrabajadasNum) || horasTrabajadasNum <= 0) return '';

  const [horas, minutos] = horaEntrada.split(':').map(Number);
  const horasDecimales = horas + minutos / 60;
  const aplicaDescanso = horasTrabajadasNum > 6;
  const horasConDescanso = aplicaDescanso ? horasTrabajadasNum + 1 : horasTrabajadasNum;
  const horaSalidaDecimal = horasDecimales + horasConDescanso;
  const horasSalida = Math.floor(horaSalidaDecimal);
  const minutosSalida = Math.round((horaSalidaDecimal - horasSalida) * 60);
  const horasSalidaFinal = horasSalida >= 24 ? horasSalida - 24 : horasSalida;
  return `${String(horasSalidaFinal).padStart(2, '0')}:${String(minutosSalida).padStart(2, '0')}`;
}
